function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchObject = void 0;
var SearchObject = exports.SearchObject = function SearchObject(obj, query) {
  for (var key in obj) {
    if (key === query) {
      return obj[key];
    }
    if (_typeof(obj[key]) === 'object') {
      return SearchObject(obj[key], query);
    }
  }
  return undefined;
};